var map = {
	"./1-sgi-ingreso-v1.png": 43,
	"./1-sgi-ingreso-v2.png": 44,
	"./2-sgi-home-v1.png": 45,
	"./2-sgi-home-v2.png": 46,
	"./3-sgi-home-v1.png": 47,
	"./3-sgi-home-v2.png": 48,
	"./4-sgi-home-v1.png": 49,
	"./4-sgi-home-v2.png": 50,
	"./5-sgi-home-v1.png": 51,
	"./5-sgi-home-v2.png": 52,
	"./6-sgi-matricula-v1.png": 53,
	"./6-sgi-matricula-v2.png": 54,
	"./7-sgi-matricula-v1.png": 55,
	"./7-sgi-matricula-v2.png": 56,
	"./8-sgi-documentos-v1.png": 57,
	"./8-sgi-documentos-v2.png": 58,
	"./login_background.png": 21,
	"./logo_ulagos.png": 23,
	"./ulagos_bco-11.png": 17,
	"./ulises_login.png": 22
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 101;